import React, { useEffect, useRef } from "react";

import HealthRecordsEmpty from "../HealthRecordsEmpty";
import HealthRecordsError from "../HealthRecordsError";
import { IPetItemResponse } from "../../../../services/Standard-of-care/standard-of-care.interface";
import Loading from "../../../../components/Loading/Loading";
import RabiesCertificateData from "./RabiesCertificateData";
import { useRabiesVaccinations } from "../../../../services/medical-history/medical-history.service";

type Props = {
  petData: IPetItemResponse;
  expanded: boolean;
};

const RabiesCertificateSection = (props: Props) => {
  const { petData, expanded } = props;
  const { fetchRabiesVaccinations, vaccinations, loading, called, error } =
    useRabiesVaccinations();
  const fetchedForPet = useRef<string | null>(null);

  useEffect(() => {
    if (expanded && fetchedForPet.current !== petData.id) {
      fetchedForPet.current = petData.id;
      fetchRabiesVaccinations(petData.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded, petData.id]);

  if (loading && !vaccinations) {
    return (
      <div className="flex justify-center items-center py-10">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <HealthRecordsError
        description="Something went wrong while loading your pet’s rabies certificate. Please try again later."
      />
    );
  }

  if (called && !loading && !vaccinations?.length) {
    return <HealthRecordsEmpty petData={petData} referredFrom="rabies_certificate" />;
  }

  if (vaccinations?.length) {
    return <RabiesCertificateData petData={petData} vaccinations={vaccinations} />;
  }

  return null;
};

export default RabiesCertificateSection;
